<template>
  <v-row>
    <v-col
      v-for="i in count"
      :key="i"
      :sm="size"
      cols="12"
    >
      <v-skeleton-loader :type="type"></v-skeleton-loader>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'Skeleton',
  props: {
    count: {
      type: Number,
      default: 6,
    },
    size: {
      type: String,
      default: '4',
    },
    type: {
      type: String,
      default: 'card',
    },
  },
}
</script>
